import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';

@Component({
  selector: 'app-single-serviceline-shared',
  templateUrl: './single-serviceline-shared.component.html',
  styleUrls: ['./single-serviceline-shared.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class SingleServicelineSharedComponent {
  @Input() services!: any[];
  @Output() selectedServices = new EventEmitter<any>();
  selected!: any;

  private readonly cdr = inject(ChangeDetectorRef);

  onRowSelect($event: {data: any}) {
    this.selected = $event.data;
    this.selectedServices.emit(this.selected);

    this.cdr.markForCheck();
  }

  onRowUnselect() {
    this.selectedServices.emit(this.selected);

    this.cdr.markForCheck();
  }
}